import React from 'react'
import { Link } from 'react-router-dom'
import BomItems from './BomItems'

export default function ItemDetailsInfo(props) {
    const { accessoryItemPrices, accessoryItemsInfo, accessoryItems, quantityAvailableToMake } = props

    const baseUrl = buildBaseUrl()

    function buildBaseUrl() {
        const urlArr = window.location.toString().split('/').slice(3)
        urlArr[0] = 'product'
        return `/${urlArr.join('/')}`
    }

    function buildBomObj(bomArr) {
        return bomArr.map(b => {
            const details = accessoryItemsInfo?.itemDetailsBatch?.find(d => d.invMastUid === b.associatedInvMastUid) || {}
            const availability = accessoryItemsInfo?.itemAvailability?.find(a => a.invMastUid === b.associatedInvMastUid) || {}
            const price = accessoryItemPrices.find(p => p.invMastUid === b.associatedInvMastUid) || {}
            const { quantity } = b
            const {
                itemCode, itemCodeUrlSanitized, invMastUid, extendedDesc,
                itemMedia, isNcnr, isAssembly
            } = details
            const { unitPrice, unitOfMeasure } = price

            return {
                itemCode,
                itemCodeUrlSanitized,
                invMastUid,
                extendedDesc,
                unitPrice,
                availability: availability.availability,
                unitOfMeasure,
                quantity,
                details: {
                    itemMedia,
                    isAssembly,
                    isNcnr,
                    invMastUid,
                    itemCode
                },
                hasPrice: !!price
            }
        })
    }

    const bom = buildBomObj(accessoryItems.filter(a => a.type === 4))

    return (
        <div>
            <div>
                <Link to={baseUrl}>
                    {'< Product Page'}
                </Link>
            </div>
            <BomItems {...{ bom, quantityAvailableToMake }} />
        </div>
    )
}